export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[100svh] flex items-center overflow-hidden bg-primary-950">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20abstract%20composition%20of%20flowing%20silky%20dark%20emerald%20green%20and%20deep%20forest%20green%20liquid%20sculpture%20with%20warm%20saffron%20golden%20light%20accents%20over%20a%20near-black%20ink%20background%2C%20subtle%20ivory%20highlights%2C%20dramatic%20soft%20cinematic%20lighting%2C%20premium%20institutional%20fine%20art%20aesthetic%2C%20layered%20organic%20forms%2C%20no%20text%20no%20people%20no%20logos&width=1800&height=1200&seq=prabhaw-hero-2026&orientation=landscape"
          alt="Prabhaw — intelligence, strategy and communication"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/90"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-6 md:px-10 pt-28 pb-20 text-center">
        <div className="max-w-4xl mx-auto flex flex-col items-center">
          <p
            data-reveal="fade"
            className="text-[11px] md:text-xs tracking-[0.4em] uppercase text-white font-mono mb-8 drop-shadow-md"
          >
            Intelligence · Strategy · Communication
          </p>

          <h1
            data-reveal
            className="font-deva text-[5.5rem] md:text-[9rem] lg:text-[11rem] leading-[0.95] text-white tracking-tight select-none drop-shadow-xl"
          >
            प्रभाव
          </h1>

          <p
            data-reveal="fade"
            style={{ ['--reveal-delay' as never]: '120ms' }}
            className="mt-6 max-w-2xl text-2xl md:text-[2rem] leading-snug text-white font-medium drop-shadow-md"
          >
            We create impact through intelligence, strategy and communication.
          </p>

          <p
            data-reveal="fade"
            style={{ ['--reveal-delay' as never]: '220ms' }}
            className="mt-5 max-w-2xl text-[15px] md:text-base leading-relaxed text-white/80 drop-shadow-sm"
          >
            Strategic intelligence, technology and communication solutions for
            governments, institutions and public leadership.
          </p>

          <div
            data-reveal="fade"
            style={{ ['--reveal-delay' as never]: '320ms' }}
            className="mt-10 flex flex-col sm:flex-row items-center gap-4"
          >
            <a
              href="#capabilities"
              className="inline-flex items-center justify-center gap-3 px-7 py-3.5 rounded-md bg-white text-primary-900 text-[15px] font-medium hover:bg-accent-500 hover:text-white transition cursor-pointer whitespace-nowrap"
            >
              Explore Our Capabilities
              <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-3 px-7 py-3.5 rounded-md border border-white/40 text-white text-[15px] font-medium hover:border-accent-500 hover:text-accent-400 transition cursor-pointer whitespace-nowrap"
            >
              Work With Us
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <a
        href="#approach"
        aria-label="Scroll to approach"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/60 hover:text-accent-400 transition-colors cursor-pointer"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase font-mono">Scroll</span>
        <span className="w-5 h-9 rounded-full border border-white/40 flex items-start justify-center pt-1.5">
          <span className="w-1 h-2 rounded-full bg-accent-400 animate-float-soft"></span>
        </span>
      </a>
    </section>
  );
}